import { render, staticRenderFns } from "./type6.vue?vue&type=template&id=8c16c496&scoped=true"
import script from "./type6.vue?vue&type=script&lang=js"
export * from "./type6.vue?vue&type=script&lang=js"
import style0 from "./type6.vue?vue&type=style&index=0&id=8c16c496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c16c496",
  null
  
)

export default component.exports